'use client';

import { useTranslations } from 'next-intl';
import { Search, X } from 'lucide-react';
import { useHistorySearchStore } from '@/features/design/history';
import { Input } from '@/shared/ui/shadcn/input';
import { Button } from '@/shared/ui/shadcn/button';

export function HistorySearchInput() {
  const t = useTranslations('history.filters');
  const searchQuery = useHistorySearchStore((state) => state.searchQuery);
  const setSearchQuery = useHistorySearchStore((state) => state.setSearchQuery);

  return (
    <div className="relative flex-1 max-w-md">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 lg:w-6 lg:h-6 text-muted-foreground" />
      <Input
        type="text"
        placeholder={t('searchPlaceholder')}
        className="pl-9 lg:pl-11 pr-10 h-9 lg:h-11"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        data-search-input
      />
      {searchQuery && (
        <Button
          size="icon"
          variant="ghost"
          className="absolute right-1 top-1/2 transform -translate-y-1/2 h-7 w-7 lg:h-9 lg:w-9"
          onClick={() => setSearchQuery('')}
        >
          <X className="h-4 w-4 lg:h-6 lg:w-6" />
        </Button>
      )}
    </div>
  );
}
